"use strict";
exports.__esModule = true;
exports.MayBpSkipSmsOptInExperiment = exports.MayBpSkipSmsOptInVariantValues = void 0;
var types_1 = require("../types");
var MayBpSkipSmsOptInVariantValues;
(function (MayBpSkipSmsOptInVariantValues) {
    MayBpSkipSmsOptInVariantValues[MayBpSkipSmsOptInVariantValues["v1"] = 0] = "v1";
    MayBpSkipSmsOptInVariantValues[MayBpSkipSmsOptInVariantValues["v2"] = 1] = "v2";
})(MayBpSkipSmsOptInVariantValues = exports.MayBpSkipSmsOptInVariantValues || (exports.MayBpSkipSmsOptInVariantValues = {}));
exports.MayBpSkipSmsOptInExperiment = {
    variantID: 'may_bp_skip_sms_opt_in',
    controlValue: types_1.CONTROL,
    variantValues: MayBpSkipSmsOptInVariantValues
};
